import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Mic, Headphones } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: QrCode,
    title: 'Share Your QR Code',
    description: 'Display your unique QR code at the venue. Guests scan it with their phone — no app needed.'
  }, {
    icon: Mic,
    title: 'Guests Record Messages',
    description: "They tap record, say what's on their heart, and hit save. It takes less than a minute."
  }, {
    icon: Headphones,
    title: 'Listen & Download',
    description: 'Every message lands in your Ihsanly dashboard. Listen, download, and relive the love anytime.'
  }];
  return <section className="py-24 bg-brown-800 text-white relative overflow-hidden" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-231">
          <h2 className="text-4xl md:text-5xl font-serif italic mb-4" data-id="element-232">
            How It Works
          </h2>
          <p className="text-cream-400 text-lg max-w-2xl mx-auto" data-id="element-233">
            Simple for you, simple for your guests. No complicated setup
            required.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-234">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 border-t-2 border-dashed border-cream-500/30 z-0" data-id="element-235" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center relative z-10" data-id="element-236">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-accent-purple to-accent-pink flex items-center justify-center mb-6 shadow-lg transform hover:scale-105 transition-transform duration-300" data-id="element-237">
                <step.icon className="w-10 h-10 text-white" data-id="element-238" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-white text-accent-pink font-bold flex items-center justify-center shadow-md" data-id="element-239">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-240">{step.title}</h3>
              <p className="text-cream-400 leading-relaxed max-w-xs" data-id="element-241">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}